import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.accordion-left-right' ).each( function( key, val ) {
        const badge = $( this ).find( '.alr__badge' )[0];
        let topOffset = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          topOffset += $( '#wpadminbar' ).outerHeight();
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top ' + topOffset,
            end: 'bottom top',
            scrub: 1,
          },
        } );
        tl.to( badge, {rotate: '360deg', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'accordion-left-right', COMPONENT );
} )( app );
